<template>
    <div class="login">
        <div class="login-wrapper">
            <div class="login-form">
                <div class="form-title">
                    <p>管理员登录</p>
                </div>
                <div class="form-item">
                    <input class="input_inner" name="username" v-model="userName" placeholder="请输入登录账号" @keyup.enter="login()" />
                </div>
                <div class="form-item">
                    <input type="password" class="input_inner" name="password" v-model="password" placeholder="请输入登录密码" @keyup.enter="login()" />
                </div>
                <div class="content_button">
                    <button class="button button--primary" @click="login()" @keyup.enter="login()">登录</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            userName: null,
            password: null,
        };
    },
    methods: {
        login() {
            if (!this.userName) {
                this.$XModal.message({
                    content: "用户名不能为空",
                    status: "error",
                });
                return;
            }
            if (!this.password) {
                this.$XModal.message({
                    content: "密码不能为空",
                    status: "error",
                });
                return;
            }
            this.$XModal.message({
                content: "正在登录",
                status: "loading",
                duration: 1500,
            });
            this.$api
                .login({
                    account: this.userName,
                    pass: this.password,
                })
                .then((result) => {
                    if (result.ok === true) {
                        localStorage.setItem(
                            "Authorization",
                            result.data.accessToken
                        );
                        this.$router.push("/");
                    } else {
                        this.$XModal.close();
                        this.$XModal.message({
                            content: result.errors,
                            status: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$XModal.message({
                        content: "登录失败！",
                        status: "error",
                    });
                });
        },
    },
};
</script>
<style>
.login {
    background-image: url(../assets/image/bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 100vh;
}
.login-wrapper {
    width: 500px;
    height: 300px;
    box-sizing: border-box;
    padding: 0 50px;
    border-radius: 5px;
    box-shadow: 0px 2px 12px 0px rgb(105 105 105 / 7%);
    background: rgba(39, 73, 118, 0.5);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: mymove 1s ease-in-out alternate;
    overflow: hidden;
    transition: 1.5s;
}
@keyframes mymove {
    0% {
        width: 0px;
        height: 5px;
    }
    10% {
        width: 50px;
        height: 5px;
    }
    15% {
        width: 100px;
        height: 5px;
    }
    20% {
        width: 150px;
        height: 5px;
    }
    25% {
        width: 200px;
        height: 5px;
    }
    30% {
        width: 250px;
        height: 5px;
    }
    35% {
        width: 300px;
        height: 5px;
    }
    40% {
        width: 350px;
        height: 5px;
    }
    45% {
        width: 450px;
        height: 5px;
    }
    50% {
        width: 500px;
        height: 5px;
    }
    55% {
        height: 30px;
    }
    60% {
        height: 60px;
    }
    65% {
        height: 90px;
    }
    70% {
        height: 120px;
    }
    75% {
        height: 150px;
    }
    80% {
        height: 180px;
    }
    85% {
        height: 210px;
    }
    90% {
        height: 240px;
    }
    95% {
        height: 240px;
    }
    100% {
        height: 300px;
    }
}
.login-form {
    width: 300px;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.form-title {
    text-align: center;
    font-size: 24px;
    margin-bottom: 30px;
    font-weight: bold;
    color: #f3f3f3;
}
p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.form-item {
    margin-bottom: 25px;
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100%;
}
.form-item::-webkit-scrollbar {
    z-index: 11;
    width: 6px;
}
.form-item::-webkit-scrollbar-corner {
    background: #fff;
}
.form-item::-webkit-scrollbar-thumb {
    border-radius: 5px;
    width: 6px;
    background: #b4bccc;
}
.form-item::-webkit-scrollbar-track {
    background: #fff;
}
.form-item::-webkit-scrollbar-track-piece {
    background: #fff;
    width: 6px;
}

.input_inner {
    padding-right: 30px;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}
.content_button {
    margin-top: 10px;
}
.button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
    -webkit-user-select: none;
}
.button--primary {
    width: 100%;
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
}
</style>
